import CustomTextInput from "@components/input/CustomTextInput";
import LabelWithInput from "@components/input/LabelWithInput";

export const Name = () => {
  const handleChange = (e: any) => {
    const value = e.target.value;
    const filteredValue = value.replace(
      /[!~@#$%^&*()_+0-9\s-{}[\]|:<>?\\/;\\'",.=`₩]/g,
      "",
    );

    e.target.value = filteredValue;
  };

  return (
    <LabelWithInput label={"이름"} required={true}>
      <CustomTextInput
        placeholder="이름 입력"
        name="name"
        onInput={handleChange}
        fontSize="1.6rem"
      />
    </LabelWithInput>
  );
};
